
import React from 'react';
import { Admin, Resource, List, Datagrid, TextField, EmailField,
         Create, AppBar, Filter, SearchInput,
         SimpleForm, TextInput, DateInput, Layout,
         email, required, regex,
         BooleanInput  } from 'react-admin';
import { Edit as ReactAdminEdit } from 'react-admin';
import { Typography } from '@mui/material';

//import authProvider from './AuthProvider';
import ptoProvider from './DataProvider';
import Header from './Header';

const Edit = ReactAdminEdit;
Edit.defaultProps = {
  undoable: false,
};

// -----------------------------------------------------------------------------
// Validators
// -----------------------------------------------------------------------------

export const validateEmail = [required(), email()];
const validatePwd = [required(),];
                     //minLength(6, 'Must be at least 6 characters long'),]
                     //regex(/\d/, 'Missing a numeral'),
                     //regex(/[!@#$%^&*-+,.]/, 'Missing a special character')]
const validateRoles = regex(/^\w+(,\s*\w+)*$/, 'Must be comma separated list, e.g., edit, view');

const attyIDValidate = [required(), regex(/^[A-Za-z0-9]+$/, 'Can only contain letters and digits')];
export const clientIDValidate = [required(),
                          regex(/^[A-Za-z0-9.-]+$/, "Can only contain letters, digits, and '.' or '-'")];

// -----------------------------------------------------------------------------
// Client Views
// -----------------------------------------------------------------------------

const ClientFilter = (props) => (
    <Filter {...props} variant="outlined">
        <SearchInput source="q" alwaysOn />
    </Filter>
);

export const ClientList = props => (
    <List {...props} filters={<ClientFilter />}>
    <Datagrid rowClick="edit">
      <TextField source="id" label="Client ID"/>
      <TextField source="name" label="Client Name"/>
      <TextField source="contact" />
      <TextField source="street1" />
      <TextField source="city_state_zip" />
      <EmailField source="email" />
    </Datagrid>
  </List>
);
//            <TextField source="cc1" />
 
const ClientAside = () => (
  <div style={{ width: 200, margin: '1em' }}>
    <Typography variant="h6" m='2rem'>Client Details</Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      Client ID is the client identifier used by your firm.  It should only
      contain letters, numbers, and basic punctuation.
    </Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      Client Name is the name of the client, e.g., ACME Corp.
    </Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      Client Contact is the primary contact person at the client, e.g., Ms. Sarah Smith.
    </Typography>
  </div>
);

const ClientEdit = props => (
  <Edit {...props} successMessage='Client record updated' aside={<ClientAside/>}>
    <SimpleForm variant='outlined' margin='none' redirect='list'>
      <TextInput source="id" label="Client ID" validate={clientIDValidate}/>
      <TextInput source="name" label="Client Name" fullWidth/>
      <TextInput source="contact" label="Client Contact" fullWidth/>
      <TextInput source="street1" fullWidth/>
      <TextInput source="city_state_zip" fullWidth/>
      <TextInput source="email" validate={email()}/>
      <TextInput source="cc1" />
    </SimpleForm>
  </Edit>
);

const ClientCreate = props => (
  <Create successMessage='Client created' {...props} aside={<ClientAside/>}>
    <SimpleForm variant='outlined' margin='none' redirect='list' >
      <TextInput source="id" label="Client ID" validate={clientIDValidate}/>
      <TextInput source="name" label="Client Name" fullWidth/>
      <TextInput source="contact" label="Client Contact" fullWidth/>
      <TextInput source="street1" fullWidth/>
      <TextInput source="city_state_zip" fullWidth/>
      <TextInput source="email" validate={email()}/>
      <TextInput source="cc1" />
    </SimpleForm>
  </Create>
);

// -----------------------------------------------------------------------------
// Attorney Views
// -----------------------------------------------------------------------------

export const AttorneyList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" label='Attorney ID'/>
      <TextField source="name" />
      <TextField source="phone" />
      <EmailField source="email" />
    </Datagrid>
  </List>
);

const AttorneyAside = () => (
  <div style={{ width: 200, margin: '1em' }}>
    <Typography variant="h6" m='2rem'>Attorney Details</Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      Attorney ID is typically the attorney's initials.
      It should only contain letters and numbers, no spaces.
    </Typography>
  </div>
);

export const AttorneyEdit = props => (
  <Edit {...props} successMessage='Attorney record updated' aside={<AttorneyAside/>}>
    <SimpleForm variant='outlined' margin='none' redirect='list'>
      <TextInput source="id" label="Attorney ID" validate={attyIDValidate}/>
      <TextInput source="name" label='Attorney Name' fullWidth/>
      <TextInput source="firm" label='Firm Name' fullWidth/>
      <TextInput source="phone" />
      <TextInput source="email" validate={email()}/>
      <TextInput source="reg_num" label="Reg. Number"/>
      <TextInput source="deposit_acct" label="Deposit Account"/>
    </SimpleForm>
  </Edit>
);

const AttorneyCreate = props => (
  <Create {...props} successMessage='Attorney created' aside={<AttorneyAside />}>
    <SimpleForm variant='outlined' margin='none' redirect='list'>
      <TextInput source="id" label="Attorney ID" validate={attyIDValidate}/>
      <TextInput source="name" label='Attorney Name' fullWidth/>
      <TextInput source="firm" label='Firm Name' fullWidth/>
      <TextInput source="phone" />
      <TextInput source="email" validate={email()}/>
      <TextInput source="reg_num" label="Reg. Number"/>
      <TextInput source="deposit_acct" label="Deposit Account"/>
    </SimpleForm>
  </Create>
);

// -----------------------------------------------------------------------------
// User Views
// -----------------------------------------------------------------------------

export const UserList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <EmailField source="email" />
      <TextField source="roles" />
      <TextField source="tenant" />
      <TextField source="org_name" />
    </Datagrid>
  </List>
);

export const UserEdit = props => (
  <Edit {...props} title='User information'>
    <SimpleForm variant='outlined' margin='none'>
      <TextInput disabled={true} source="email" />
      <BooleanInput disabled={true} source="active" />
      <BooleanInput disabled={true} source="paid" />
      <DateInput disabled={true} source="confirmed_at" label="Confirmed On"/>
      <TextInput disabled={true} source="roles" />
      <TextInput disabled={true} source="tenant" />
      <TextInput disabled={true} source="org_name" label="Organization" />
    </SimpleForm>
  </Edit>
);
//        <TextInput disabled={true} source="license_key" />
//        <TextInput disabled={true} source="password" />

const CreateUserAside = () => (
  <div style={{ width: 200, margin: '1em' }}>
    <Typography variant="h6" m='2rem'>New User Details</Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      You must be an administrative user to create new users.
    </Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      Temporary password must be at least 6 characters long and include
      one number and one special character
    </Typography>
    <Typography variant="body2" style={{marginTop: 15}}>
      Roles is a comma separated list of roles.  Include "admin" role to give user administrative rights.
    </Typography>
  </div>
);

export const UserCreate = props => (
  <Create aside={<CreateUserAside />} successMessage='User created' {...props}>
    <SimpleForm variant='outlined' redirect="list">
      <TextInput source="id" label='Email address' type='email' validate={validateEmail}/>
      <TextInput source="password" label='Temporary password'validate={validatePwd}/>
      <TextInput source="roles" validate={validateRoles}/>
      <BooleanInput source='sendmail' defaultValue={true} label='Send confirmation email'/>
    </SimpleForm>
  </Create>
);
//        <TextInput label='Repeat password' value='foobar'/>


const dataProvider = ptoProvider;

const MyAppBar = props => {
  return (
    <AppBar elevation={0} style={{marginTop: "3.5em", borderBottom: '1px solid gray'}}
            {...props} color='transparent' logout={null}>
    </AppBar>
  );
}

const MyLayout = (props) => {
  return (<Layout {...props} appBar={MyAppBar}/>);
}

      
class FlowAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.store = props.store;
  }

  render() {
    console.log('theme', this.props.theme);
    return (
      <div>
        <Header store={this.store} />
        <div style={{marginTop: "4em"}}>
          <Admin title="Admin" theme={this.props.theme} layout={MyLayout}
                 basename="/admin" dataProvider={dataProvider}        >
            <Resource name="clients" list={ClientList} edit={ClientEdit} create={ClientCreate}/>
            <Resource name="attorneys" list={AttorneyList} edit={AttorneyEdit} create={AttorneyCreate}/>
            <Resource name="users" list={UserList} edit={UserEdit} create={UserCreate}/>
          </Admin>
        </div>
      </div>
    );
  }
}
//        <Header store={this.store}/>

export default FlowAdmin;

